import React, { Component } from 'react';

class Pdf extends Component {
  componentDidMount = () => {
    this.downloadPDF();
  }

  downloadPDF = () => {
    const linkSource = this.props.source.uri;
    const downloadLink = document.createElement('a');
    const fileName = `full-report-${this.props.scanDate}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  render() {
    return (
      <div />
    );
  }
}

export default Pdf;
